export default __webpack_public_path__ + "static/media/speaker.4353e67a.svg";